import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import LoadingSkeleton from "../../../../loader/TableLoader";
import Pagination from "../../../../commanPage/pagination/Pagination";
import { NoItemsLeftInTable } from "../../../../../helpers/helpers";

function ServiceLotListTable({ offers, loading }) {
  const totalNumberRow = 20;
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const [currentPage, setCurrentPage] = useState(0);
  const navigate = useNavigate();

  return (
    <div className="flex column full-width mt-1">
      {loading ? (
        <div className="valign-wrapper justify-center cover white">
          <LoadingSkeleton
            headerData={[
              "Lots Id",
              "Service Title",
              "Category",
              "EMD Amount",
              "Starting price",
              "Max Decrement",
              "Action",
            ]}
          />
        </div>
      ) : (
        <>
          <div
            className={`${
              !isTablet && "table-container-style"
            } mb-1 full-width`}
          >
            <table
              className={`responsive-table centered ${
                isTablet ? "auction_table table-style" : "custom-table-style"
              } `}
            >
              <thead>
                <tr>
                  <th>Lots No.</th>
                  <th>Service Title</th>
                  <th>Category</th>
                  <th>Sub-Category</th>
                  <th>EMD Amount </th>
                  <th>Starting price </th>
                  <th>Max Decrement</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {offers
                  ?.slice(currentPage, currentPage + totalNumberRow)
                  ?.map((items, index) => (
                    <tr key={items?._id}>
                      <td>{index + 1}</td>
                      <td style={{ width: !isTablet && "230px" }}>
                        <span
                          className="NoOfline"
                          style={{ WebkitLineClamp: 1 }}
                        >
                          {items?.serviceDetails?.title}
                        </span>
                      </td>
                      <td>{items?.serviceDetails?.category}</td>
                      <td> {items?.serviceDetails?.subCategory}</td>
                      <td>{items?.EMDAmount}</td>
                      <td>
                        {items?.startingPrice > 0
                          ? items?.startingPrice
                          : "N/A"}
                      </td>
                      <td>
                        {items?.minimumBidDecrease}
                      </td>
                      <td>
                        <button
                          className="cercle-purple-text text-decoration-underLine pointer"
                          onClick={() =>
                            navigate(
                              `/service-reverse-auction/singleOffer/${items.auction}/${items._id}`
                            )
                          }
                        >
                          View EMD
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          {offers?.length === 0 && <NoItemsLeftInTable />}
          {offers?.length > 20 && (
            <Pagination
              Data={offers}
              totalNumberRow={totalNumberRow}
              setCurrentPage={setCurrentPage}
            />
          )}
        </>
      )}
    </div>
  );
}

export default ServiceLotListTable;
